import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'account.job-profiles.update-confirmation-modal.header',
    defaultMessage: 'Confirm updating Job Profile',
  },
  firstParagraph: {
    id: 'account.job-profiles.update-confirmation-modal.first-paragraph',
    defaultMessage: 'Please make sure that you actually want to change dimension benchmarks.',
  },
  secondParagraph: {
    id: 'account.jjob-profiles.update-confirmation-modal.second-paragraph',
    defaultMessage: 'If you do, all SuperMatches based on this Job Profile will be deleted.',
  },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const UpdateJobProfileDimensionBenchmarksConfirmationDialog = ({ visible, confirm, hide }) => {
  const { formatMessage } = useIntl();

  const header = <div className="dashboard-panel-header">{formatMessage(messages.header)}</div>;

  return (
    <Dialog visible={visible} onHide={hide} header={header} modal>
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <div className="mt20 flex-center">
        <Button type="button" className="p-button-secondary" label={formatMessage(messages.cancel)} onClick={hide} />
        <Button
          type="button"
          className="p-button-primary"
          label={formatMessage(messages.submit)}
          onClick={confirm}
        />
      </div>
    </Dialog>
  );
};

export default UpdateJobProfileDimensionBenchmarksConfirmationDialog;
